<template>
  <div class="base-table-uploadProgress">
    <span
      class="f24"
      :style="{
        color: status === 'progress' ? '#277FAF' : status === 'error' ? '#ce1212' : '#26BC2C',
      }"
      >{{
        status === 'progress'
          ? uploadProgress + '%'
          : status === 'error'
          ? localStorage.translations.pages.common.notifications['oshibka']
          : '100%'
      }}</span
    >
    <v-progress-linear
      :value="status === 'progress' ? uploadProgress : '100'"
      :color="status === 'progress' ? '#277FAF' : status === 'error' ? '#ce1212' : '#26BC2C'"
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: 'BaseTableUploadProgress',
  props: { status: String, uploadProgress: [Number, String] },
}
</script>

<style lang="scss" scoped>
.base-table-uploadProgress {
  display: grid;
  grid-row-gap: 10px;
  max-width: 300px;
}
</style>
